/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

/**
 * Determine if at least one attribute contains facet buckets.
 *
 * @param {Array} facets
 * @param {Array} attributeCodes
 * @returns {boolean}
 */
export const hasFacetBucketsForAttributes = (facets = [], attributeCodes = []) => {
    if (!Array.isArray(facets) || !Array.isArray(attributeCodes) || attributeCodes.length === 0) {
        return false
    }

    return attributeCodes.some(attributeCode => {
        const facet = facets.find(item => item.attribute === attributeCode)
        return Boolean(facet?.buckets?.length)
    })
}
